import { render, staticRenderFns } from "./crew-school-combobox.vue?vue&type=template&id=5e124408&"
import script from "./crew-school-combobox.vue?vue&type=script&lang=js&"
export * from "./crew-school-combobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports